module.exports = __webpack_public_path__ + "img/L3_open.40806568.svg";